var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 336,
    viewBox: "0 0 307 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.5,
    cy: 319.5,
    rx: 77.5,
    ry: 16.5,
    fill: "#123384"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1237_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6588 136.744C24.7233 136.599 24.7716 136.454 24.836 136.309C24.8843 136.212 24.9165 136.099 24.9648 136.002C25.0132 135.89 25.0615 135.793 25.1098 135.68C26.7364 131.809 29.2649 128.552 32.3894 126.729L33.2752 126.213L140.729 64.0581L248.184 1.93528L249.069 1.4192C252.194 -0.387069 255.334 -0.403197 257.96 1.01602C258.04 1.04827 258.104 1.09665 258.169 1.12891C258.233 1.17729 258.314 1.20954 258.378 1.2418L272.567 9.43452L264.386 12.9019L292.763 163.564C293.488 167.451 292.844 171.741 291.217 175.595C291.169 175.708 291.12 175.805 291.088 175.918C291.04 176.015 291.008 176.127 290.959 176.224C289.333 180.095 286.804 183.369 283.68 185.175L69.367 309.13L71.348 318.581L57.9162 310.791C57.9162 310.791 57.7712 310.711 57.7068 310.678C55.0817 309.275 53.1168 306.501 52.376 302.615L23.306 148.34C22.5974 144.598 23.1772 140.486 24.675 136.744H24.6588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9306 318.581L297.611 193.255C304.165 189.465 308.144 179.305 306.485 170.547L277.85 18.4822C276.207 9.72499 269.555 5.70927 263 9.49921L46.3204 134.809C39.7656 138.599 35.7876 148.759 37.4464 157.517L66.0816 309.582C67.7243 318.339 74.3758 322.355 80.9306 318.565V318.581Z",
    fill: "url(#paint0_linear_1237_1217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2062 134.293L154.66 72.1382L188.337 250.911L81.8164 318.049C74.7784 322.129 67.8209 318.823 66.2909 310.679L37.237 156.42C35.707 148.276 40.1682 138.373 47.2062 134.293Z",
    fill: "url(#paint1_linear_1237_1217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.115 9.99936L154.66 72.1544L188.127 249.798L296.741 193.771C303.779 189.691 308.24 179.789 306.71 171.644L277.656 17.3696C276.126 9.22525 269.169 5.91913 262.131 9.99936H262.115Z",
    fill: "url(#paint2_linear_1237_1217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.341 183.24C303.586 187.642 300.542 191.561 296.741 193.755L81.8164 318.065C78.0156 320.258 74.2469 320.29 71.3319 318.597L167.625 140.954L305.341 183.256V183.24Z",
    fill: "url(#paint3_linear_1237_1217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.606 144.825C40.3615 140.422 43.4054 136.503 47.2062 134.309L262.115 9.99939C265.916 7.80606 269.684 7.77381 272.599 9.46718L176.306 187.111L38.606 144.825Z",
    fill: "url(#paint4_linear_1237_1217)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1237_1217",
    x1: 246.511,
    y1: 121.021,
    x2: 6.4357,
    y2: 259.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1237_1217",
    x1: 32.4253,
    y1: 433.898,
    x2: 96.0894,
    y2: 207.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#54B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#48AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A9BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1237_1217",
    x1: 408.436,
    y1: 216.018,
    x2: 180.814,
    y2: 158.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#54B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#48AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A9BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1237_1217",
    x1: 258.087,
    y1: 418.44,
    x2: 128.036,
    y2: 193.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3796D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#3088C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1237_1217",
    x1: 144.089,
    y1: 35.5312,
    x2: -12.1635,
    y2: 262.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1237_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 320,
    fill: "white",
    transform: "translate(23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.bbe5e4bf69c5d7c1071fde1c962009fc.svg";
export { ForwardRef as ReactComponent };